import { z } from 'zod';

/**
 * W13: authored text in a definition — the text itself (written before languages existed) or one text per
 * language (`{ "en": "Consignee", "de": "Empfänger" }`). Renderers read it through `useText`.
 */
export const localizedTextSchema = z.record(z.string(), z.string());
export const localizedString = z.union([z.string(), localizedTextSchema]);
export type LocalizedString = z.infer<typeof localizedString>;
